// extracted by mini-css-extract-plugin
export default {"wrapperBodyRuleDetails":"styles_wrapperBodyRuleDetails__JmmQa","labelInput":"styles_labelInput__FJD8m"};